function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const ChangeDate = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 50 40"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M37.8,5.7h-1.6V2.5H33v3.2H17V2.5h-3.2v3.2h-1.6c-1.8,0-3.2,1.4-3.2,3.2v25.4c0,1.7,1.4,3.2,3.2,3.2 h25.7c1.8,0,3.2-1.4,3.2-3.2V8.9C41.1,7.1,39.6,5.7,37.8,5.7z M37.8,34.3H12.2V16.8h25.7V34.3z M37.8,13.6H12.2V8.9h1.6H17H33h3.2 h1.6V13.6z",
  fill: "#808285"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.2,19.4c-0.1-0.1-0.3,0-0.4,0.1l-1.3,1.4c-1.1-0.9-2.5-1.5-4-1.5c-3.3,0-6,2.7-6,6s2.7,6,6,6 c1.6,0,3.1-0.6,4.2-1.8c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.7,0c-0.9,0.9-2.2,1.5-3.5,1.5c-2.8,0-5-2.2-5-5s2.2-5,5-5 c1.2,0,2.4,0.4,3.3,1.2l-1.2,1.2c-0.1,0.1-0.1,0.3-0.1,0.4c0.1,0.1,0.2,0.2,0.3,0.2h3.3c0.2,0,0.4-0.2,0.4-0.4v-3.3 C31.4,19.6,31.4,19.4,31.2,19.4z"
}));

export default ChangeDate;